import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumInvoicesOrCredits implements BaseEnumType {
  private static allValues: EnumInvoicesOrCredits[] = []; // make sure this is top-most
  
  public static invoicesAndCredits = new EnumInvoicesOrCredits(1, "InvoicesAndCredits", "enum_invoices_or_credits_invoices_and_credits");
  public static invoicesOnly = new EnumInvoicesOrCredits(2, "InvoicesOnly", "enum_invoices_or_credits_invoices_only");
  public static creditsOnly = new EnumInvoicesOrCredits(3, "CreditsOnly", "enum_invoices_or_credits_credits_only");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumInvoicesOrCredits.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isInvoicesAndCredits() { return this === EnumInvoicesOrCredits.invoicesAndCredits; }
  public isInvoicesOnly() { return this === EnumInvoicesOrCredits.invoicesOnly; }
  public isCreditsOnly() { return this === EnumInvoicesOrCredits.creditsOnly; }

  public static getValues(): readonly EnumInvoicesOrCredits[] {
    return EnumInvoicesOrCredits.allValues;
  }

  public static getValuesExcept0(): readonly EnumInvoicesOrCredits[] {
    return EnumInvoicesOrCredits.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumInvoicesOrCredits {
    const found = EnumInvoicesOrCredits.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumInvoicesOrCredits - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumInvoicesOrCredits): EnumInvoicesOrCredits {
    const found = name ? EnumInvoicesOrCredits.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumInvoicesOrCredits - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumInvoicesOrCredits>): boolean {
    return this.key === other?.key;
  }
}